export enum SettingsCallApiActionTypes {
    SETTINGS_CALL_API_REQUEST_SEND = 'settings_call_api_request_send',
    SETTINGS_CALL_API_ERROR = 'settings_call_api_error',
    SETTINGS_CALL_API_SUCCESS = 'settings_call_api_success',

    SETTINGS_CALL_API_UPDATE_REQUEST = 'settings_call_api_update_request',
    SETTINGS_CALL_API_UPDATE_SUCCESS = 'settings_call_api_update_success',
    SETTINGS_CALL_API_UPDATE_ERROR = 'settings_call_api_update_error',
}